import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";

/**
 * Lazy called function to get grade groups for console settings.
 * Accepts optional { school_id } at call time to filter by school.
 */
const useLazyContentSettingsGroupsGet = (data) => {
  const includeArchived = data?.include_archived || false;

  const createResource = useCallback(
    (options) => {
      const params = new URLSearchParams({
        include_archived: includeArchived,
      });
      if (options?.school_id) {
        params.set("school_id", options.school_id);
      }
      return `${API_BASE_URL}/api/v3/visibility/content-settings-groups/?${params}`;
    },
    [includeArchived],
  );

  return useLazyRestQuery(createResource);
};

export default useLazyContentSettingsGroupsGet;
